import { useState } from "react";
import { Link } from "react-router-dom";
import type { Movie, MediaType } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";

interface LatestSectionProps {
  movies: Movie[];
}

const tabDefs: { key: MediaType | "全部"; label: string }[] = [
  { key: "全部", label: "全部" },
  { key: "电影", label: "电影" },
  { key: "电视剧", label: "电视剧" },
  { key: "综艺", label: "综艺" },
];

export default function LatestSection({ movies }: LatestSectionProps) {
  const [tab, setTab] = useState<MediaType | "全部">("全部");

  const list = (tab === "全部" ? movies : movies.filter((m) => m.type === tab)).slice(0, 10);

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2 mb-5">
        {tabDefs.map((def) => (
          <button
            key={def.key}
            type="button"
            onClick={() => setTab(def.key)}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
              tab === def.key
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:text-foreground-950 border border-background-200"
            }`}
          >
            {def.label}
          </button>
        ))}
        <Link
          to="/category/movie"
          className="ml-auto hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
        >
          全部更新
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      </div>

      {list.length === 0 ? (
        <div className="w-full flex flex-col items-center justify-center gap-3 py-16 rounded-lg border border-dashed border-background-300 bg-background-100/60">
          <i className="ri-inbox-2-line text-3xl text-foreground-500"></i>
          <p className="text-sm text-foreground-600">暂无内容，稍后再试</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-5">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
}